import React from "react";

const RadioButtons = ({
  label,
  isRequired,
  className,
  name,
  disabled,
  yesChecked,
  noChecked,
  noButtonClassName,
  showDiv = false,
  DivClassName = "",
  isStyledButton,
  onYesClicked,
  onNoClicked,
  child,
  hideTd,
  showError = false,
}) => {
  const spanEle = (
    <>
      <span>
        <input
          type="radio"
          className={className}
          name={`${name}_C`}
          id={`${name}_C-yes`}
          required={isRequired}
          disabled={disabled}
          checked={yesChecked}
          onClick={(e) => {
            onYesClicked();
            e.stopPropagation();
          }}
          onChange={() => {}}
        />
        {isStyledButton ? (
          <label
            htmlFor={`${name}_C-yes`}
            className={className}
            disabled={disabled}
          >
            Yes
          </label>
        ) : (
          <label htmlFor={`${name}_C-yes`} className="detail-form-label">
            <span className={showError ? "has-error" : ""}></span>
            Yes
          </label>
        )}
      </span>
      <span className="">
        <input
          type="radio"
          className={noButtonClassName !== "" ? noButtonClassName : className}
          name={`${name}_C`}
          id={`${name}_C-no`}
          required={isRequired}
          disabled={disabled}
          checked={noChecked}
          onClick={(e) => {
            onNoClicked();
            e.stopPropagation();
          }}
          onChange={() => {}}
        />
        {isStyledButton ? (
          <label
            htmlFor={`${name}_C-no`}
            className={noButtonClassName}
            disabled={disabled}
          >
            No
          </label>
        ) : (
          <label htmlFor={`${name}_C-no`} className="detail-form-label">
            <span className={showError ? "has-error" : ""}></span>
            No
          </label>
        )}
      </span>
    </>
  );
  return (
    <>
      {label && (
        <td>
          {label} {isRequired && <span className="col-red">*</span>}
        </td>
      )}
      {!hideTd ? (
        <td>
          {showDiv ? <div className={DivClassName}>{spanEle}</div> : spanEle}
          {child ? child : ""}
        </td>
      ) : (
        <>
          {showDiv ? <div className={DivClassName}>{spanEle}</div> : spanEle}
          {child ? child : ""}
        </>
      )}
    </>
  );
};

export default RadioButtons;
